import Config from "./Config";
import { PERMISSIONS } from "./permission";

export const ALLOW_MerchantsItemSoldReport = (Config.ITEM_SOLD_REPORT_MERCHANTS || "")
  .split(",")
  .map((id) => id.trim())
  .filter(Boolean);

// Account-wide grant: every store whose owner email (users.email, which is
// `data.email` in the session for owner, employee and superadmin-switched logins)
// is listed, so stores the merchant adds later are covered without a code change.
export const ALLOW_EmailsItemSoldReport = (Config.ITEM_SOLD_REPORT_EMAILS || "")
  .split(",")
  .map((email) => email.trim().toLowerCase())
  .filter(Boolean);

export const isItemSoldReportStore = (merchantId, storeEmail = "") =>
  ALLOW_MerchantsItemSoldReport.includes(merchantId) ||
  ALLOW_EmailsItemSoldReport.includes(String(storeEmail || "").trim().toLowerCase());

export const canViewItemSoldReport = (
  merchantId,
  permissions = [],
  requiredPermission = PERMISSIONS.MENU_ITEM_SOLD_REPORT,
  storeEmail = "",
) =>
  isItemSoldReportStore(merchantId, storeEmail) &&
  (!permissions.length || permissions.includes(requiredPermission));

// PO Products Report — same merchant allowlist as the Category Sold Report,
// but its own "PPR" permission for employees.
export const canViewPoProductsReport = (merchantId, permissions = [], storeEmail = "") =>
  canViewItemSoldReport(merchantId, permissions, PERMISSIONS.MENU_PO_PRODUCTS_REPORT, storeEmail);
